import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICalculatorState } from '../../types';

interface ISetRedirectUrlPayloadAction {
  url: string;
}

interface IOpenAuthorizationModalPayloadAction {
  redirectUrl?: string;
}

// Новый интерфейс для сохранения результата saveOffer
interface ISaveOfferResultPayloadAction {
  applicationId: number;
  redirectUrl: string;
}

export const initialState: ICalculatorState = {
  authorizationModal: {
    isOpen: false,
    redirectUrl: null,
  },
  user: {
    isAuthorized: false,
  },
  saveOfferResult: null,
  isErrorGetOffersListing: false,
  entityId: 0,
  pageType: 'newBuilding',
  initialFormState: {
    objectCost: 1000000,
    loanTermYears: 30,
    downPayment: 500000,
    regionId: 2,
    realEstateType: 'newBuilding',
    benefitProgram: undefined,
    objectType: 'flat',
  },
  defaultRedirectUrl: '',
  financePlatformEnabled: false,
  skipOffersFetch: true,
  programsVersion: 'd8f8d185-dd6e-4b3e-bd8e-beac33fb037e',
};

export const calculatorSlice = createSlice({
  initialState,
  name: 'calculator',
  reducers: {
    openAuthorizationModal: (state, action: PayloadAction<IOpenAuthorizationModalPayloadAction | undefined>) => {
      state.authorizationModal.isOpen = true;
      state.authorizationModal.redirectUrl = action.payload?.redirectUrl || null;
    },
    closeAuthorizationModal: state => {
      state.authorizationModal.isOpen = false;
      state.authorizationModal.redirectUrl = null;
      state.saveOfferResult = null;
    },
    setSaveOfferResult: (state, action: PayloadAction<ISaveOfferResultPayloadAction>) => {
      state.saveOfferResult = {
        applicationId: action.payload.applicationId,
        redirectUrl: action.payload.redirectUrl,
      };
    },
    clearSaveOfferResult: state => {
      state.saveOfferResult = null;
    },
    setIsErrorGetOffersListing: (state, action: PayloadAction<boolean>) => {
      state.isErrorGetOffersListing = action.payload;
    },
    setRedirectUrl: (state, action: PayloadAction<ISetRedirectUrlPayloadAction>) => {
      state.defaultRedirectUrl = action.payload.url;
    },
    setFinancePlatformEnabled: (state, action: PayloadAction<boolean>) => {
      state.financePlatformEnabled = action.payload;
    },
    setDefaultFormState: (state, action: PayloadAction<Partial<ICalculatorState['initialFormState']>>) => {
      state.initialFormState = { ...state.initialFormState, ...action.payload };
    },
    setSkipOffersFetch: (state, action: PayloadAction<boolean>) => {
      state.skipOffersFetch = action.payload;
    },
    setProgramsVersion: (state, action: PayloadAction<string>) => {
      state.programsVersion = action.payload;
    },
  },
});

export const {
  openAuthorizationModal,
  closeAuthorizationModal,
  setSaveOfferResult,
  clearSaveOfferResult,
  setIsErrorGetOffersListing,
  setRedirectUrl,
  setFinancePlatformEnabled,
  setDefaultFormState,
  setSkipOffersFetch,
  setProgramsVersion,
} = calculatorSlice.actions;
